import React from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Modal from '../common/Modal';
import Image from '../common/Image';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
  },
  heading: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  popupCloseBtn: {
    cursor: 'pointer',
  },
  content: {
    width: '98%',
    height: '67vh',
    overflowY: 'auto',
    background: '#f2f2f6',
    padding: '10px',
  },
  tabs: {
    width: '100%',
    height: '80px',
    display: 'flex',
    borderRadius: '10px',
    overflow: 'hidden',
    marginTop: '10px',
    border: '2px solid #E4E7EC',
  },
  comp: {
    height: '100%',
    width: '33%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '5px',
    borderRight: '2px solid #E4E7EC',
  },
  track: {
    height: '100%',
    width: '33%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '5px',
    borderRight: '2px solid #E4E7EC',
  },
  due: {
    height: '100%',
    width: '34%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '5px',
  },
  numberComp: {
    fontSize: '24px',
    color: '#027A48',
  },
  numberTrack: {
    fontSize: '24px',
    color: '#F79009',
  },
  numberDue: {
    fontSize: '24px',
    color: '#D92D20',
  },
  divider: {
    display: 'flex',
    height: '20px',
    width: '100%',
    marginTop: '10px',
    alignItems: 'center',
    justifyContent: 'center',
  },
  line: {
    width: '32%',
    height: '2px',
    background: '#D0D5DD',
  },
  date: {
    width: '36%',
    height: '10px',
    display: 'flex',
    background: '#E4E7EC',
    padding: '10px 5px',
    alignItems: 'center',
    justifyContent: 'center',
  },
  user: {
    marginTop: '10px',
    width: '96%',
    height: '50px',
    display: 'flex',
    background: '#fff',
    padding: '10px',
  },
  img: {
    width: '15%',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  info: {
    width: '55%',
    height: '50px',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  status: {
    width: '30%',
    height: '50px',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    alignItems: 'flex-end',
  },
  smallText: {
    fontSize: '12px',
  },
}));

export const UserStats = ({ setSelectedJ }) => {
  const classes = useStyles();
  return (
    <Modal isOpen height="72vh" width="500px">
      <Grid className={classes.container}>
        <Grid className={classes.heading}>
          <Typography>Journey Stats</Typography>
          <Grid item xs={1}>
            <CloseIcon className={classes.popupCloseBtn} onClick={() => setSelectedJ(null)} />
          </Grid>
        </Grid>
        <Grid className={classes.content}>
          <Grid className={classes.tabContainer}>
            <Typography>Users</Typography>
            <Grid className={classes.tabs}>
              <Grid className={classes.comp}>
                <Typography className={classes.numberComp}>05</Typography>
                <Typography style={{ color: '#027A48' }}>Completed</Typography>
              </Grid>
              <Grid className={classes.track}>
                <Typography className={classes.numberTrack}>05</Typography>
                <Typography>On Track</Typography>
              </Grid>
              <Grid className={classes.due}>
                <Typography className={classes.numberDue}>01</Typography>
                <Typography>Past Due</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid className={classes.stats}>
            <Grid className={classes.divider}>
              <Grid className={classes.line}></Grid>
              <Grid className={classes.date}>
                <Typography>Due on</Typography>
                <Typography> 30 Feb, 2023</Typography>
              </Grid>
              <Grid className={classes.line}></Grid>
            </Grid>
            <Grid className={classes.users}>
              <Grid className={classes.user}>
                <Grid className={classes.img}>
                  <Image
                    style={{ width: '30px', height: '30px', borderRadius: '50%' }}
                    src="https://images.pexels.com/photos/771742/pexels-photo-771742.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                  />
                </Grid>
                <Grid className={classes.info}>
                  <Typography>Ashis Ratre</Typography>
                  <Typography className={classes.smallText}>Sales Associate</Typography>
                </Grid>
                <Grid className={classes.status}>
                  <Typography>Completed on</Typography>
                  <Typography className={classes.smallText}>29 July, 2023</Typography>
                </Grid>
              </Grid>
              <Grid className={classes.user}>
                <Grid className={classes.img}>
                  <Image
                    style={{ width: '30px', height: '30px', borderRadius: '50%' }}
                    src="https://images.pexels.com/photos/771742/pexels-photo-771742.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                  />
                </Grid>
                <Grid className={classes.info}>
                  <Typography>Ashis Ratre</Typography>
                  <Typography className={classes.smallText}>Sales Associate</Typography>
                </Grid>
                <Grid className={classes.status}>
                  <Typography>Completed on</Typography>
                  <Typography className={classes.smallText}>29 July, 2023</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};
